//TODO make dynamic
import ExampleModule1 from "../assets/modules/data1.json";
import ExampleModule2 from "../assets/modules/data2.json";
import ExampleModule3 from "../assets/modules/data3.json";
import ExampleModule4 from "../assets/modules/data4.json";
import ExampleModule5 from "../assets/modules/data5.json";
import ExampleModule6 from "../assets/modules/data6.json";
import ExampleModule7 from "../assets/modules/data7.json";
import ExampleModule8 from "../assets/modules/data8.json";
import ExampleModule9 from "../assets/modules/data9.json";
import ExampleModule10 from "../assets/modules/data10.json";
import ExampleModule11 from "../assets/modules/data11.json";
import ExampleModule12 from "../assets/modules/data12.json";
import ExampleModule13 from "../assets/modules/data13.json";

//Singleton
class ExampleModules {
  constructor() {
    this.modules = {};
  }
  addModule(key,value){
    this.modules[key] = value;
  }
  getAllModulesKeys(allEnabled){
    return Object.keys(this.modules).filter((x => (true ||  this.modules[x].enabled)))
    .sort(function(a, b){
        // ASC  -> a.length - b.length
        // DESC -> b.length - a.length
        return a.trim().length - b.trim().length;
      });
  }
  getModuleByKey(key){
    return this.modules[key].data;
  }
  getModuleEnabledByKey(key){
    return key !== undefined && this.modules[key].enabled;
  }
}

const instance = new ExampleModules();
instance.addModule(ExampleModule1.name,ExampleModule1);
instance.addModule(ExampleModule2.name,ExampleModule2);
instance.addModule(ExampleModule5.name,ExampleModule5);
instance.addModule(ExampleModule7.name,ExampleModule7);
instance.addModule(ExampleModule6.name,ExampleModule6);
instance.addModule(ExampleModule3.name,ExampleModule3);
instance.addModule(ExampleModule4.name,ExampleModule4);
instance.addModule(ExampleModule8.name,ExampleModule8);
instance.addModule(ExampleModule9.name,ExampleModule9);
instance.addModule(ExampleModule10.name,ExampleModule10);
instance.addModule(ExampleModule11.name,ExampleModule11);
instance.addModule(ExampleModule12.name,ExampleModule12);
instance.addModule(ExampleModule13.name,ExampleModule13);
Object.freeze(instance);
export default instance;
